/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import InvoiceHistoryListPage from './invoiceHistoryList/InvoiceHistoryListPage'
import {DrawerComponent} from '../../../_metronic/assets/ts/components'

const InvoiceHistory: React.FC = () => {
  useEffect(() => {
    setTimeout(() => {
      DrawerComponent.reinitialization()
    }, 100)
  }, [])
  return (
    <div className='card mb-5 mb-xl-10'>
      <div className='card-header border-0'>
        <div className='card-title m-0'>
          <h3 className='fw-bolder m-0'>Histórico de Faturas</h3>
        </div>
      </div>

      <div className='card-body border-top '>
        <InvoiceHistoryListPage />
      </div>
    </div>
  )
}

export {InvoiceHistory}
